module.exports = ".mat-dialog-content {\r\n  min-height: 122px;\r\n}"